import React__default from 'react';
import styled from 'styled-components';
import { withTheming, Spacing, Text, TextStyle, TextColor } from '@doordash/design-language';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CountryCodeHelperItem = function CountryCodeHelperItem(_ref) {
  var countryLabel = _ref.countryLabel,
      dialCode = _ref.dialCode,
      isHighlighted = _ref.isHighlighted,
      size = _ref.size,
      flagEmoji = _ref.flagEmoji,
      props = _objectWithoutProperties(_ref, ["countryLabel", "dialCode", "isHighlighted", "size", "flagEmoji"]);

  return /*#__PURE__*/React__default.createElement(Container, _extends({
    isHighlighted: isHighlighted
  }, props), flagEmoji ? /*#__PURE__*/React__default.createElement(Text, {
    "aria-hidden": true,
    styles: TextStyle["Menu".concat(size, "Body")]
  }, flagEmoji) : null, /*#__PURE__*/React__default.createElement(Text, {
    styles: TextStyle["Menu".concat(size, "Body")]
  }, countryLabel), /*#__PURE__*/React__default.createElement(Text, {
    styles: TextStyle["Menu".concat(size, "Body")],
    color: TextColor.TextTertiary
  }, dialCode));
};

var Container = withTheming(styled.button.withConfig({
  displayName: "CountryCodeHelperItem__Container",
  componentId: "sc-w3fg0d-0"
})(["width:100%;display:flex;cursor:pointer;align-items:center;border:none;padding:", "px ", "px;background-color:", ";& > *:not(:last-child){margin-right:", "px;}", " &:hover{background-color:", ";}"], Spacing.XSmall, Spacing.XLarge, function (_ref2) {
  var theme = _ref2.theme;
  return theme.Colors.BackgroundPrimary;
}, Spacing.Small, function (_ref3) {
  var theme = _ref3.theme,
      isHighlighted = _ref3.isHighlighted;
  return isHighlighted && "\n    background-color: ".concat(theme.Colors.BackgroundSecondary, ";\n  ");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.Colors.BackgroundSecondary;
}));

export { CountryCodeHelperItem as default };
